export default __webpack_public_path__ + "static/media/arrow_back_ios_new-24px_orange.91961b28.svg";